import { ChangeEvent, KeyboardEvent, MouseEvent } from 'react';
import { Sized, StandartHTMLInputProps } from '@optimus-web/common';

export type HandleCounterInputValueChange = (
    e: ChangeEvent<HTMLInputElement> | MouseEvent | KeyboardEvent,
    newValue: number
) => void;

export interface CounterInputProps extends Sized, StandartHTMLInputProps {
    onChange: HandleCounterInputValueChange;
    value: number;
    name: string;
    max?: number;
    min?: number;
    step?: number;
}
